import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

/**
 * Animated Intro Component
 * Shows a simple welcome screen on first app launch
 */
const Intro = ({ onComplete }: any) => {
  const { t } = useTranslation();
  const [currentScreen, setCurrentScreen] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const navigate = useNavigate();

  const handleContinue = () => {
    if (currentScreen === 0) {
      // Go directly to Analyze team moods screen
      setIsTransitioning(true);
      setTimeout(() => {
        //setCurrentScreen(2);
        setIsTransitioning(false);
        //navigate("/app/home");
        navigate("/app/intro2");
      }, 300);
    }
  };

  const handleSkipIntro = () => {
    localStorage.setItem("isIntroSeen", "true");
    navigate("/app/login");
  };

  const handleFinish = () => {
    setIsExiting(true);
    localStorage.setItem("isIntroSeen", "true");
    setTimeout(() => {
      //onComplete?.();
      navigate("/app/home", { replace: true });
    }, 500);
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100%",
        height: "100%",
        zIndex: 9999,
        backgroundColor: "#fafafa",
        opacity: isExiting ? 0 : 1,
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      {/* Main Content */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          height: "100%",
          width: "100%",
          maxWidth: "100%",
          padding: "24px",
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        {/* Screen 1: Welcome to Experience */}
        {currentScreen === 0 && (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                width: "100%",
                maxWidth: "100%",
                flex: 1,
                paddingTop: "40px",
              }}
            >
              <div>
                <img
                  src="/logo512.png"
                  alt="Experience App Icon"
                  style={{
                    objectFit: "contain",
                    padding: "8px",
                    width: "156px",
                    height: "156px",
                  }}
                  onError={(e) => {
                  }}
                />
              </div>

              {/* Title */}
              <h1
                style={{
                  fontSize: "clamp(32px, 8vw, 36px)",
                  fontWeight: "bold",
                  color: "#111827",
                  marginTop: "48px",
                  textAlign: "center",
                  transition: "all 0.5s ease",
                  opacity: isExiting ? 0 : 1,
                  transform: isExiting ? "translateY(16px)" : "translateY(0)",
                  width: "100%",
                  maxWidth: "100%",
                  padding: "0 16px",
                  boxSizing: "border-box",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                }}
              >
                Experience
              </h1>
              <h2
                style={{
                  fontSize: "clamp(16px, 2vw, 20px)",
                  color: "#666",
                  marginBottom: "48px",
                  textAlign: "center",
                  transition: "all 0.5s ease",
                  opacity: isExiting ? 0 : 1,
                  fontWeight: "450",
                  marginTop: "0",
                }}
              >
                Productivity through self-awareness new TEST
              </h2>
            </div>

            <button onClick={handleContinue} className="proceed-button">
              Continue
            </button>
            <button onClick={handleSkipIntro} className="proceed-button">
              Skip intro
            </button>
          </>
        )}

        {/* Screen 2: Analyze team moods */}
        {currentScreen === 1 && (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                maxWidth: "100%",
                flex: 1,
                transition: "all 0.3s ease",
                opacity: isTransitioning ? 0 : 1,
                transform: isTransitioning
                  ? "translateX(20px)"
                  : "translateX(0)",
                animation: "slideIn 0.3s ease",
                boxSizing: "border-box",
              }}
            >
              {/* Animated Icon/Illustration */}
              <div
                style={{
                  marginBottom: "32px",
                  transition: "all 0.5s ease",
                  opacity: isExiting ? 0 : 1,
                  transform: isExiting
                    ? "scale(0.75) translateY(16px)"
                    : "scale(1) translateY(0)",
                  animation: !isExiting
                    ? "float 3s ease-in-out infinite"
                    : "none",
                }}
              >
                <div
                  style={{
                    width: "128px",
                    height: "128px",
                    background:
                      "linear-gradient(to bottom right, #3b82f6, #9333ea)",
                    borderRadius: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                    transform: "rotate(3deg)",
                    transition: "transform 0.3s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "rotate(6deg)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "rotate(3deg)")
                  }
                >
                  <span style={{ fontSize: "64px" }}>👥</span>
                </div>
              </div>

              {/* Title */}
              <h1
                style={{
                  fontSize: "clamp(28px, 8vw, 36px)",
                  fontWeight: "bold",
                  color: "#111827",
                  marginBottom: "48px",
                  textAlign: "center",
                  transition: "all 0.5s ease",
                  opacity: isExiting ? 0 : 1,
                  transform: isExiting ? "translateY(16px)" : "translateY(0)",
                  width: "100%",
                  maxWidth: "100%",
                  padding: "0 16px",
                  boxSizing: "border-box",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                }}
              >
                Analyze team moods
              </h1>
            </div>

            {/* Finish Button */}
            <button onClick={handleFinish} className="proceed-button">
              {t("finish", "Finish")}
            </button>
          </>
        )}
      </div>

      {/* Animated Background Elements */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflow: "hidden",
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "80px",
            left: "40px",
            width: "80px",
            height: "80px",
            backgroundColor: "#bfdbfe",
            borderRadius: "50%",
            opacity: 0.2,
            filter: "blur(40px)",
            animation: "float 6s ease-in-out infinite",
            animationDelay: "0s",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "80px",
            right: "40px",
            width: "128px",
            height: "128px",
            backgroundColor: "#e9d5ff",
            borderRadius: "50%",
            opacity: 0.2,
            filter: "blur(40px)",
            animation: "float 8s ease-in-out infinite",
            animationDelay: "2s",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "25%",
            width: "64px",
            height: "64px",
            backgroundColor: "#fbcfe8",
            borderRadius: "50%",
            opacity: 0.2,
            filter: "blur(40px)",
            animation: "float 7s ease-in-out infinite",
            animationDelay: "1s",
          }}
        />
      </div>

      {/* CSS Animations */}
      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }
                @keyframes slideIn {
                    from {
                        opacity: 0;
                        transform: translateX(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }
      `}</style>
    </div>
  );
};

export default Intro;
